import * as types from './types';
import Option from '../../../helpers/request/option';
import i18n from '../../../i18n';

const locale = i18n.locale;
const messages = i18n.messages[locale];


const actions = {};
let OptionRequest;

actions.optionConfigRequest = ({ commit }, data) => {
  const { quizId, stepId } = data;

  OptionRequest = new Option({ quizId, stepId });
};

actions.optionAdd = ({ commit, state }, data) => {
  const optionsLength = state.list.filter((option) => !option.other).length;
  const option = {
    label: data.label || `${messages.general.labels.option} ${optionsLength + 1}`,
    other: data.other,
  };

  OptionRequest.post(option, { showLoader: true })
    .then(response => commit(types.OPTION_ADD, { data: response.data }));
};

actions.optionRemove = ({ commit }, data) => {
  OptionRequest.delete(data.id, { showLoader: true })
    .then(() => commit(types.OPTION_REMOVE, data.index));
};

actions.optionUpdateText = ({ commit }, data) => {
  OptionRequest.put(data.id, { label: data.event.target.value }, { showLoader: true })
    .then(response => commit(types.OPTION_UPDATE_LABEL, response.data));
};

actions.optionUpdateOtherAnswer = ({ commit, state }, data) => {
  const otherOptionIndex = state.list.findIndex(option => option.other);

  if (data.event.target.checked) {
    actions.optionAdd({ commit, state }, { label: messages.general.labels.other, other: true });
    return;
  }

  actions.optionRemove({ commit }, {
    id: state.list[otherOptionIndex].id,
    index: otherOptionIndex,
  });
};

actions.optionSetActive = ({ commit }, options) => {
  commit(types.OPTION_SET_ACTIVE, options);
};

actions.optionResetActive = ({ commit }) => {
  commit(types.OPTION_RESET_ACTIVE);
};

export default actions;



/** WEBPACK FOOTER **
 ** ./src/store/modules/option/actions.js
 **/